import { RouteConfig } from "vue-router";
import { Roles } from "../models/emums/roles";

const routes: Array<RouteConfig> = [
    {
        path: "/supervisor-encory",
        component: require("@/layouts/layout.vue").default,
        children: [
            {
                path: "list",
                name: "Supervisor Encory list",
                component: require("@/components/supervisor-encory/supervisor-encory-list.vue").default,
                meta: {
                    roles: [Roles.Admin, Roles.DisponentAdmin, Roles.Disponent, Roles.User]
                }
            }
        ]
    }
];

export default routes;
